import { type SalesView } from "../../sales-views-context";

export const customerTypeRevenueAndRoas = {
  id: "customer_type_revenue_and_roas",
  name: "Customer type: Revenue and ROAS",
  isTemplate: true,
  data: {
    filters: {
      attributionModel: "northbeam_custom",
      attributionWindow: "1",
      nbAccountingMode: "accrual",
      granularity: "platform",
      timeGranularity: "daily",
      dateRange: "last7Days",
      compareDateRange: "lastPeriod",
      breakdowns: [
        {
          key: "Platform (Northbeam)",
          values: [],
        },
      ],
    },
    columnConfigurations: [
      {
        name: "Name",
        width: 450,
        visible: true,
      },
      {
        name: "Spend",
        width: 180,
        visible: true,
      },
      {
        name: "Attributed Rev (1st time)",
        width: 278,
        visible: true,
      },
      {
        name: "ROAS (1st time)",
        width: 182,
        visible: true,
      },
      {
        name: "LTV ROAS",
        width: 120,
        visible: true,
      },
      {
        name: "LTV CAC",
        width: 120,
        visible: true,
      },
      {
        name: "Attributed Rev (Returning)",
        width: 288,
        visible: true,
      },
      {
        name: "ROAS (Returning)",
        width: 192,
        visible: true,
      },
    ],
    selectedMetricBoxes: [
      "Spend",
      "Attributed Rev",
      "ROAS",
      "CAC",
      "LTV CAC",
      "LTV ROAS",
    ],
  },
} as unknown as SalesView;
